import React, { useMemo, useState } from "react";
import { usePohrebka2 } from "../../context/Pohrebka2Context";

const STUHA_BARVY = [
  "krémová",
  "černá",
  "bílá",
  "bordó",
  "červená",
  "růžová",
  "fialová",
  "modrá",
  "světle modrá",
  "zelená",
  "tmavě zelená",
  "zlatá",
  "stříbrná",
];

const KVETINARSTVI_OPTIONS = [
  {
    id: "bartova_ck",
    nazev: "Květiny Bártová",
    email: "radka775@seznam.cz",
    telefon: "+420606783630",
  },
  {
    id: "milujemekvetiny_ck",
    nazev: "Květinářství Milujemekvetiny.cz",
    email: "radka.stara.1@seznam.cz",
    telefon: "+420723322655",
  },
  {
    id: "zahradnictvi_krumlov",
    nazev: "Zahradnictví Krumlov",
    email: "info@zahradnictvi-krumlov.cz",
    telefon: "+420731618808",
  },
  {
    id: "flamengo_ck",
    nazev: "Flamengo květiny",
    email: "info@flamengo.cz",
    telefon: "+420380731528",
  },
];

const cardStyle = {
  background: "#ffffff",
  border: "1px solid #e5e7eb",
  borderRadius: 24,
  padding: 20,
  display: "grid",
  gap: 18,
};

const titleStyle = {
  fontSize: 28,
  fontWeight: 900,
  color: "#111827",
};

const subStyle = {
  fontSize: 14,
  lineHeight: 1.6,
  color: "#4b5563",
};

const gridStyle = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
  gap: 14,
};

const labelStyle = {
  display: "block",
  marginBottom: 6,
  fontSize: 13,
  fontWeight: 800,
  color: "#374151",
};

const inputStyle = {
  width: "100%",
  border: "1px solid #d1d5db",
  borderRadius: 12,
  padding: "11px 12px",
  fontSize: 14,
  background: "#fff",
  color: "#111827",
  boxSizing: "border-box",
};

const textareaStyle = {
  ...inputStyle,
  minHeight: 90,
  resize: "vertical",
};

const buttonStyle = {
  border: "1px solid #d1d5db",
  borderRadius: 12,
  padding: "10px 14px",
  fontSize: 14,
  fontWeight: 800,
  background: "#fff",
  color: "#111827",
  cursor: "pointer",
};

function round2(value) {
  return Math.round((Number(value || 0) + Number.EPSILON) * 100) / 100;
}

function formatMoney(value) {
  return `${round2(value).toFixed(2).replace(".", ",")} Kč`;
}

function formatDateTime(value) {
  if (!value) return "—";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return String(value);
  return `${d.toLocaleDateString("cs-CZ")} ${d.toLocaleTimeString("cs-CZ", {
    hour: "2-digit",
    minute: "2-digit",
  })}`;
}

function createEmptyKvetina(base = {}) {
  return {
    objednano: false,
    stavObjednavky: "",
    objednanoAt: "",
    datumObjednani: "",
    casObjednani: "",
    emailLog: [],
    dodavatel: "",
    dodavatelId: "",
    dodavatelEmail: "",
    dodavatelTelefon: "",
    typVazby: "",
    barva: "",
    stuhaBarva: "",
    stuhaText1: "",
    stuhaText2: "",
    poznamka: "",
    mnozstvi: 1,
    cenaBezDph: "",
    cenaSDph: "",
    dph: 21,
    ...base,
  };
}

export default function Pohrebka2KvetinyForm() {
  const { order, currentOrderId, patchSection } = usePohrebka2();
  const [sending, setSending] = useState(false);

  const kvetiny = order?.kvetiny || {};
  const rawItems = Array.isArray(kvetiny?.items) ? kvetiny.items : [];
  const items = rawItems.length ? rawItems.map((x) => createEmptyKvetina(x)) : [createEmptyKvetina()];
  const copyToCustomer = !!kvetiny?.copyToCustomer;

  const isFlowersOrderLocked = useMemo(() => {
    return (Array.isArray(items) ? items : []).some((item) => {
      const emailLog = Array.isArray(item?.emailLog) ? item.emailLog : [];
      return !!item?.objednano || emailLog.length > 0;
    });
  }, [items]);

  const zesnuly =
    [
      order?.zesnulaOsoba?.jmeno || order?.vstupniInformace?.jmenoZesnuleho || "",
      order?.zesnulaOsoba?.prijmeni || order?.vstupniInformace?.prijmeniZesnuleho || "",
    ]
      .filter(Boolean)
      .join(" ")
      .trim() || "Nezadáno";

  const objednavatelEmail =
    order?.vypravitel?.email ||
    order?.zaklad?.email ||
    "";

  const setItems = (next) => {
    patchSection("kvetiny", { items: next });
  };

  const setCopyToCustomer = (value) => {
    patchSection("kvetiny", { copyToCustomer: !!value });
  };

  const setItemField = (index, key, value) => {
    const next = [...items];
    const current = createEmptyKvetina(next[index]);

    next[index] = createEmptyKvetina({
      ...current,
      [key]: key === "mnozstvi" ? 1 : value,
      mnozstvi: 1,
    });

    setItems(next);
  };

  const setDodavatelFromOption = (index, selectedId) => {
    const option = KVETINARSTVI_OPTIONS.find((x) => x.id === selectedId);
    const next = [...items];

    if (!option) {
      const current = createEmptyKvetina(next[index]);
      next[index] = createEmptyKvetina({
        ...current,
        dodavatelId: "",
        dodavatel: "",
        dodavatelEmail: "",
        dodavatelTelefon: "",
      });
      setItems(next);
      return;
    }

    if (index === 0) {
      for (let i = 0; i < next.length; i += 1) {
        const current = createEmptyKvetina(next[i]);
        next[i] = createEmptyKvetina({
          ...current,
          dodavatelId: option.id,
          dodavatel: option.nazev,
          dodavatelEmail: option.email || "",
          dodavatelTelefon: option.telefon || "",
          mnozstvi: 1,
        });
      }
    } else {
      const current = createEmptyKvetina(next[index]);
      next[index] = createEmptyKvetina({
        ...current,
        dodavatelId: option.id,
        dodavatel: option.nazev,
        dodavatelEmail: option.email || "",
        dodavatelTelefon: option.telefon || "",
        mnozstvi: 1,
      });
    }

    setItems(next);
  };

  const addItem = () => {
    const first = items[0] || createEmptyKvetina();
    const nextItem = createEmptyKvetina({
      dodavatel: first?.dodavatel || "",
      dodavatelId: first?.dodavatelId || "",
      dodavatelEmail: first?.dodavatelEmail || "",
      dodavatelTelefon: first?.dodavatelTelefon || "",
      mnozstvi: 1,
    });
    setItems([...(items || []), nextItem]);
  };

  const removeItem = (index) => {
    const next = [...items];
    next.splice(index, 1);
    setItems(next.length ? next : [createEmptyKvetina()]);
  };

  const getAuthToken = () => {
    try {
      return (
        localStorage.getItem("token") ||
        localStorage.getItem("authToken") ||
        localStorage.getItem("jwt") ||
        localStorage.getItem("jwtToken") ||
        localStorage.getItem("accessToken") ||
        sessionStorage.getItem("token") ||
        sessionStorage.getItem("authToken") ||
        ""
      );
    } catch {
      return "";
    }
  };

  const sendableItems = useMemo(() => {
    return items.filter((item) =>
      !!(
        String(item?.typVazby || "").trim() ||
        String(item?.barva || "").trim() ||
        String(item?.stuhaBarva || "").trim() ||
        String(item?.stuhaText1 || "").trim() ||
        String(item?.stuhaText2 || "").trim() ||
        String(item?.poznamka || "").trim() ||
        (Number(item?.cenaSDph || 0) || 0) > 0
      )
    );
  }, [items]);

  const sendAllFlowersOrder = async () => {
    if (!sendableItems.length) {
      alert("Nejprve vyplň alespoň jednu květinu.");
      return;
    }

    const supplierEmail = String(items?.[0]?.dodavatelEmail || "").trim();
    if (!supplierEmail) {
      alert("Nejprve vyber květinářství u první květiny.");
      return;
    }

    const token = getAuthToken();
    if (!token) {
      alert("Chybí token přihlášení. Přihlas se znovu.");
      return;
    }

    setSending(true);

    try {
      const isReorder = items.some(
        (item) => !!item?.objednano || (Array.isArray(item?.emailLog) && item.emailLog.length > 0)
      );

      const payloadItems = sendableItems.map((item) =>
        createEmptyKvetina({
          ...item,
          dodavatel: items?.[0]?.dodavatel || "",
          dodavatelId: items?.[0]?.dodavatelId || "",
          dodavatelEmail: items?.[0]?.dodavatelEmail || "",
          dodavatelTelefon: items?.[0]?.dodavatelTelefon || "",
          mnozstvi: 1,
        })
      );

      const res = await fetch("/api/pohrebka2/kvetiny/send-order", {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          "x-auth-token": token,
        },
        body: JSON.stringify({
          orderId: currentOrderId || order?.id || "",
          order,
          items: payloadItems,
          isReorder,
          copyToCustomer: !!copyToCustomer,
        }),
      });

      const data = await res.json();

      if (!res.ok || !data?.ok) {
        throw new Error(data?.error || "Nepodařilo se odeslat květinovou objednávku.");
      }

      const nowIso = data?.sentAt || new Date().toISOString();
      const now = new Date(nowIso);
      const datumObjednani = now.toLocaleDateString("cs-CZ");
      const casObjednani = now.toLocaleTimeString("cs-CZ", {
        hour: "2-digit",
        minute: "2-digit",
      });

      const next = items.map((item) => {
        const shouldMark = !!(
          String(item?.typVazby || "").trim() ||
          String(item?.barva || "").trim() ||
          String(item?.stuhaBarva || "").trim() ||
          String(item?.stuhaText1 || "").trim() ||
          String(item?.stuhaText2 || "").trim() ||
          String(item?.poznamka || "").trim() ||
          (Number(item?.cenaSDph || 0) || 0) > 0
        );

        if (!shouldMark) return createEmptyKvetina(item);

        const current = createEmptyKvetina(item);

        return createEmptyKvetina({
          ...current,
          objednano: true,
          stavObjednavky: isReorder ? "doobjednano" : "objednano",
          objednanoAt: nowIso,
          datumObjednani,
          casObjednani,
          dodavatel: items?.[0]?.dodavatel || current?.dodavatel || "",
          dodavatelId: items?.[0]?.dodavatelId || current?.dodavatelId || "",
          dodavatelEmail: items?.[0]?.dodavatelEmail || current?.dodavatelEmail || "",
          dodavatelTelefon: items?.[0]?.dodavatelTelefon || current?.dodavatelTelefon || "",
          mnozstvi: 1,
          emailLog: [
            ...(Array.isArray(current?.emailLog) ? current.emailLog : []),
            {
              sentAt: nowIso,
              mode: isReorder ? "doobjednani" : "prvni_objednani",
              to: data?.to || "",
              cc: data?.cc || "",
              subject: data?.subject || "",
            },
          ],
        });
      });

      patchSection("kvetiny", {
        items: next,
        copyToCustomer: !!copyToCustomer,
        lastSentAt: nowIso,
        lastMode: isReorder ? "doobjednani" : "prvni_objednani",
      });

      alert(isReorder ? "Doobjednávka byla odeslána." : "Květinová objednávka byla odeslána.");
    } catch (err) {
      alert(err?.message || "Chyba při odeslání.");
    } finally {
      setSending(false);
    }
  };

  const getOrderHistory = () => {
    const logs = [];
    (Array.isArray(items) ? items : []).forEach((item, itemIndex) => {
      const emailLog = Array.isArray(item?.emailLog) ? item.emailLog : [];
      emailLog.forEach((entry, logIndex) => {
        logs.push({
          itemIndex,
          logIndex,
          sentAt: entry?.sentAt || "",
          mode: entry?.mode || "",
          to: entry?.to || "",
          cc: entry?.cc || "",
          subject: entry?.subject || "",
        });
      });
    });

    logs.sort((a, b) => {
      const aa = a.sentAt ? new Date(a.sentAt).getTime() : 0;
      const bb = b.sentAt ? new Date(b.sentAt).getTime() : 0;
      return bb - aa;
    });

    return logs;
  };

  const orderHistory = getOrderHistory();
  const lastOrderLog = orderHistory.length ? orderHistory[0] : null;

  const totals = useMemo(() => {
    return items.reduce(
      (acc, item) => {
        const mnozstvi = 1;
        const cenaSDphZaKus = Number(item?.cenaSDph || 0) || 0;
        const dphPct = Number(item?.dph || 0) || 0;

        const celkem = round2(cenaSDphZaKus * mnozstvi);
        const bez = dphPct > 0 ? round2(celkem / (1 + dphPct / 100)) : round2(celkem);
        const dphCastka = round2(celkem - bez);

        acc.bez += bez;
        acc.dph += dphCastka;
        acc.celkem += celkem;
        return acc;
      },
      { bez: 0, dph: 0, celkem: 0 }
    );
  }, [items]);

  return (
    <div style={cardStyle}>
      <div style={titleStyle}>Květiny</div>

      <div style={subStyle}>
        Dodavatel se vybírá pouze u první květiny. Všechny další květiny ho automaticky přebírají.
        Odesílání je vždy celé najednou až na konci poslední květiny. Každá květina má pevně 1 kus,
        aby nevznikl zmatek ve stuhách a textech.
      </div>

      <div
        style={{
          padding: 14,
          borderRadius: 16,
          background: "#f9fafb",
          border: "1px solid #e5e7eb",
        }}
      >
        <div style={{ fontSize: 13, fontWeight: 700, color: "#6b7280", marginBottom: 6 }}>
          Zesnulý
        </div>
        <div style={{ fontSize: 20, fontWeight: 900, color: "#111827" }}>{zesnuly}</div>
      </div>

      <div style={{ display: "grid", gap: 18 }}>
        {items.map((item, index) => {
          const mnozstvi = 1;
          const cenaSDphZaKus = Number(item?.cenaSDph || 0) || 0;
          const dphPct = Number(item?.dph || 0) || 0;

          const cenaCelkem = round2(cenaSDphZaKus * mnozstvi);
          const cenaBezDph = dphPct > 0 ? round2(cenaCelkem / (1 + dphPct / 100)) : round2(cenaCelkem);
          const dphCastka = round2(cenaCelkem - cenaBezDph);

          const emailLog = Array.isArray(item?.emailLog) ? item.emailLog : [];
          const lastLog = emailLog.length ? emailLog[emailLog.length - 1] : null;
          const isLast = index === items.length - 1;
          const isAlreadyOrdered = !!item?.objednano || emailLog.length > 0;

          return (
            <div
              key={`kvetina-${index}`}
              style={{
                border: "1px solid #e5e7eb",
                borderRadius: 18,
                padding: 18,
                background: "#fff",
                display: "grid",
                gap: 16,
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: 12,
                  flexWrap: "wrap",
                  alignItems: "center",
                }}
              >
                <div style={{ fontSize: 20, fontWeight: 900, color: "#111827" }}>
                  Květina {index + 1}
                </div>

                <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                  <span
                    style={{
                      ...buttonStyle,
                      cursor: "default",
                      background: isAlreadyOrdered ? "#ecfdf5" : "#f3f4f6",
                      border: isAlreadyOrdered ? "1px solid #86efac" : "1px solid #d1d5db",
                    }}
                  >
                    {isAlreadyOrdered
                      ? item?.stavObjednavky === "doobjednano"
                        ? "Doobjednáno"
                        : "Objednáno"
                      : "Neobjednáno"}
                  </span>

                  <button type="button" onClick={() => removeItem(index)} style={buttonStyle}>
                    Smazat
                  </button>
                </div>
              </div>

              <div style={gridStyle}>
                {index === 0 ? (
                  <>
                    <div>
                      <label style={labelStyle}>Dodavatel / květinářství</label>
                      <select
                        value={item?.dodavatelId || ""}
                        onChange={(e) => setDodavatelFromOption(index, e.target.value)}
                        style={inputStyle}
                      >
                        <option value="">Vyber květinářství</option>
                        {KVETINARSTVI_OPTIONS.map((opt) => (
                          <option key={opt.id} value={opt.id}>
                            {opt.nazev}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div>
                      <label style={labelStyle}>E-mail květinářství</label>
                      <input
                        type="text"
                        value={item?.dodavatelEmail || ""}
                        onChange={(e) => setItemField(index, "dodavatelEmail", e.target.value)}
                        placeholder="E-mail"
                        style={inputStyle}
                      />
                    </div>

                    <div>
                      <label style={labelStyle}>Telefon květinářství</label>
                      <input
                        type="text"
                        value={item?.dodavatelTelefon || ""}
                        onChange={(e) => setItemField(index, "dodavatelTelefon", e.target.value)}
                        placeholder="Telefon"
                        style={inputStyle}
                      />
                    </div>
                  </>
                ) : (
                  <div
                    style={{
                      padding: 12,
                      borderRadius: 12,
                      background: "#f8fafc",
                      border: "1px solid #e2e8f0",
                      color: "#334155",
                      gridColumn: "1 / -1",
                    }}
                  >
                    Dodavatel se přebírá z první květiny:
                    <strong> {items?.[0]?.dodavatel || "není vybrán"}</strong>
                    {" · "}
                    {items?.[0]?.dodavatelEmail || "-"}
                    {" · "}
                    {items?.[0]?.dodavatelTelefon || "-"}
                  </div>
                )}

                <div>
                  <label style={labelStyle}>Typ vazby</label>
                    <select
                      value={item?.typVazby || ""}
                      onChange={(e) => setItemField(index, "typVazby", e.target.value)}
                      style={inputStyle}
                    >
                      <option value="">Vyber</option>
                      <option value="vence">Věnec</option>
                      <option value="kytice">Kytice</option>
                      <option value="aranzma">Aranžmá</option>
                      <option value="vazana_kvetina_do_ruky">Vázaná květina do ruky</option>
                      <option value="vazba_na_rakev">Vazba na rakev</option>
                      <option value="vyzdoba_do_rakve">Výzdoba do rakve</option>
                      <option value="srdce">Srdce</option>
                      <option value="kos">Koš</option>
                      <option value="jine">Jiné</option>
                    </select>
                </div>

                <div>
                  <label style={labelStyle}>Barva květin</label>
                  <input
                    type="text"
                    value={item?.barva || ""}
                    onChange={(e) => setItemField(index, "barva", e.target.value)}
                    placeholder="Např. bílá, červená..."
                    style={inputStyle}
                  />
                </div>

                <div>
                  <label style={labelStyle}>Barva stuhy</label>
                    <select
                      value={item?.stuhaBarva || ""}
                      onChange={(e) => setItemField(index, "stuhaBarva", e.target.value)}
                      style={inputStyle}
                    >
                      <option value="">Vyber barvu stuhy</option>
                      {STUHA_BARVY.map((barva) => (
                        <option key={barva} value={barva}>
                          {barva}
                        </option>
                      ))}
                    </select>
                </div>

                <div>
                  <label style={labelStyle}>Text stuha 1</label>
                  <input
                    type="text"
                    value={item?.stuhaText1 || ""}
                    onChange={(e) => setItemField(index, "stuhaText1", e.target.value)}
                    placeholder="První strana stuhy"
                    style={inputStyle}
                  />
                </div>

                <div>
                  <label style={labelStyle}>Text stuha 2</label>
                  <input
                    type="text"
                    value={item?.stuhaText2 || ""}
                    onChange={(e) => setItemField(index, "stuhaText2", e.target.value)}
                    placeholder="Druhá strana stuhy"
                    style={inputStyle}
                  />
                </div>

                <div>
                  <label style={labelStyle}>Počet kusů</label>
                  <input
                    type="number"
                    min="1"
                    step="1"
                    value={1}
                    disabled
                    style={{
                      ...inputStyle,
                      background: "#f3f4f6",
                      color: "#6b7280",
                      cursor: "not-allowed",
                    }}
                  />
                </div>

                <div>
                  <label style={labelStyle}>Cena s DPH</label>
                  <input
                    type="number"
                    step="0.01"
                    value={item?.cenaSDph || ""}
                    onChange={(e) => setItemField(index, "cenaSDph", e.target.value)}
                    placeholder="0"
                    style={inputStyle}
                  />
                </div>

                <div>
                  <label style={labelStyle}>DPH %</label>
                  <input
                    type="number"
                    step="1"
                    value={item?.dph ?? 21}
                    onChange={(e) => setItemField(index, "dph", e.target.value)}
                    style={inputStyle}
                  />
                </div>

                <div style={{ gridColumn: "1 / -1" }}>
                  <label style={labelStyle}>Poznámka ke květinám</label>
                  <textarea
                    value={item?.poznamka || ""}
                    onChange={(e) => setItemField(index, "poznamka", e.target.value)}
                    placeholder="Specifikace vazby, termín, kontakt..."
                    style={textareaStyle}
                  />
                </div>
              </div>

              <div
                style={{
                  padding: 14,
                  borderRadius: 14,
                  background: "#f9fafb",
                  border: "1px solid #e5e7eb",
                  display: "grid",
                  gap: 8,
                }}
              >
                <div style={{ fontSize: 13, color: "#6b7280" }}>
                  Naposledy odesláno: <strong>{lastLog?.sentAt ? formatDateTime(lastLog.sentAt) : "zatím ne"}</strong>
                </div>

                <div style={{ fontSize: 13, color: "#6b7280" }}>
                  Režim:{" "}
                  <strong>
                    {lastLog?.mode === "doobjednani"
                      ? "doobjednání"
                      : lastLog?.mode === "prvni_objednani"
                        ? "první objednávka"
                        : "—"}
                  </strong>
                </div>

                <div style={{ fontSize: 13, color: "#6b7280" }}>
                  Bez DPH: <strong>{formatMoney(cenaBezDph)}</strong> · DPH: <strong>{formatMoney(dphCastka)}</strong> · Celkem:{" "}
                  <strong>{formatMoney(cenaCelkem)}</strong>
                </div>

                {isLast ? (
                  <>
                    <label
                      style={{
                        display: "flex",
                        gap: 8,
                        alignItems: "center",
                        fontWeight: 700,
                        color: "#374151",
                        marginTop: 6,
                      }}
                    >
                      <input
                        type="checkbox"
                        checked={!!copyToCustomer}
                        onChange={(e) => setCopyToCustomer(e.target.checked)}
                      />
                      Poslat kopii objednavateli celé zakázky
                    </label>

                    <div style={{ fontSize: 13, color: "#6b7280" }}>
                      E-mail objednavatele: <strong>{objednavatelEmail || "není vyplněn"}</strong>
                    </div>

                    <div style={{ display: "flex", gap: 10, flexWrap: "wrap", marginTop: 8 }}>
                      <button type="button" onClick={addItem} style={buttonStyle}>
                        + Další květina
                      </button>

                      <button
                        type="button"
                        onClick={sendAllFlowersOrder}
                        disabled={sending}
                        style={{
                          ...buttonStyle,
                          background: "#111827",
                          color: "#fff",
                          border: "1px solid #111827",
                          opacity: sending ? 0.7 : 1,
                        }}
                      >
                        {sending
                          ? "Odesílám celou objednávku..."
                          : isAlreadyOrdered
                            ? "Odeslat celou doobjednávku"
                            : "Odeslat celou květinovou objednávku"}
                      </button>
                    </div>
                  </>
                ) : (
                  <div
                    style={{
                      ...buttonStyle,
                      cursor: "default",
                      background: "#f8fafc",
                      border: "1px solid #e2e8f0",
                      display: "inline-flex",
                      width: "fit-content",
                    }}
                  >
                    Odeslání je vždy až u poslední květiny
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>

      <div style={{ marginTop: 6, display: "flex", gap: 10, flexWrap: "wrap" }}>
        <div
          style={{
            marginTop: 22,
            padding: 16,
            borderRadius: 16,
            border: "1px solid #e5e7eb",
            background: "#f8fafc",
            display: "grid",
            gap: 10,
          }}
        >
          <div style={{ fontSize: 15, fontWeight: 800, color: "#111827" }}>
            Historie odeslání květin
          </div>

          <div style={{ fontSize: 14, color: "#4b5563", lineHeight: 1.5 }}>
            Přehled všech odeslání k této zakázce. Poslední záznam je nahoře.
          </div>

          {lastOrderLog ? (
            <div
              style={{
                padding: 12,
                borderRadius: 12,
                background: "#fff",
                border: "1px solid #e5e7eb",
                display: "grid",
                gap: 6,
              }}
            >
              <div>
                <strong>Poslední odeslání:</strong> {formatDateTime(lastOrderLog.sentAt)}
              </div>
              <div>
                <strong>Typ:</strong>{" "}
                {lastOrderLog.mode === "doobjednani"
                  ? "Doobjednávka"
                  : lastOrderLog.mode === "prvni_objednani"
                    ? "První objednávka"
                    : "—"}
              </div>
              <div><strong>Komu:</strong> {lastOrderLog.to || "-"}</div>
              <div><strong>Kopie:</strong> {lastOrderLog.cc || "-"}</div>
            </div>
          ) : (
            <div
              style={{
                padding: 12,
                borderRadius: 12,
                background: "#fff",
                border: "1px solid #e5e7eb",
                color: "#6b7280",
              }}
            >
              Zatím nebylo nic odesláno.
            </div>
          )}

          {orderHistory.length ? (
            <div style={{ display: "grid", gap: 10 }}>
              {orderHistory.map((log, idx) => (
                <div
                  key={`order-history-${idx}`}
                  style={{
                    padding: 12,
                    borderRadius: 12,
                    background: "#fff",
                    border: "1px solid #e5e7eb",
                    display: "grid",
                    gap: 4,
                  }}
                >
                  <div>
                    <strong>{idx + 1}. odeslání:</strong> {formatDateTime(log.sentAt)}
                  </div>
                  <div>
                    <strong>Typ:</strong>{" "}
                    {log.mode === "doobjednani"
                      ? "Doobjednávka"
                      : log.mode === "prvni_objednani"
                        ? "První objednávka"
                        : "—"}
                  </div>
                  <div><strong>Komu:</strong> {log.to || "-"}</div>
                  <div><strong>Kopie:</strong> {log.cc || "-"}</div>
                  <div><strong>Předmět:</strong> {log.subject || "-"}</div>
                </div>
              ))}
            </div>
          ) : null}
        </div>

        <div
          style={{
            ...buttonStyle,
            cursor: "default",
            display: "inline-flex",
            alignItems: "center",
            background: "#ecfeff",
            border: "1px solid #a5f3fc",
          }}
        >
          Květiny bez DPH: {formatMoney(totals.bez)}
        </div>

        <div
          style={{
            ...buttonStyle,
            cursor: "default",
            display: "inline-flex",
            alignItems: "center",
            background: "#f9fafb",
          }}
        >
          Květiny DPH: {formatMoney(totals.dph)}
        </div>

        <div
          style={{
            ...buttonStyle,
            cursor: "default",
            display: "inline-flex",
            alignItems: "center",
            background: "#ecfeff",
            border: "1px solid #a5f3fc",
          }}
        >
          Květiny celkem: {formatMoney(totals.celkem)}
        </div>
      </div>
    </div>
  );
}
